/* ============================================================
   SORBPACK Theme JavaScript
   - Countdown timers
   - Cart AJAX (add to cart with toast)
   - Product page interactivity (tabs, gallery, qty)
   - Filter sidebar (collection page)
   - Checkout form + Formspree order submission
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ---- Countdown Timers ---- */
  function startCountdown(el) {
    if (!el) return;
    const targetMs = Date.now() + (parseInt(el.dataset.hours || 5) * 3600 + parseInt(el.dataset.minutes || 14) * 60) * 1000;
    function tick() {
      const left = Math.max(0, targetMs - Date.now());
      const h = Math.floor(left / 3.6e6);
      const m = Math.floor(left % 3.6e6 / 6e4);
      const s = Math.floor(left % 6e4 / 1000);
      const pad = n => String(n).padStart(2, '0');
      const hEl = el.querySelector('[data-countdown="h"]');
      const mEl = el.querySelector('[data-countdown="m"]');
      const sEl = el.querySelector('[data-countdown="s"]');
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
      if (left > 0) setTimeout(tick, 1000);
    }
    tick();
  }
  document.querySelectorAll('[data-countdown-target]').forEach(startCountdown);

  /* ---- Toast (no GSAP dependency) ---- */
  function _showToast(html, duration, extraStyle) {
    var existing = document.getElementById('cart-toast');
    if (existing) existing.remove();
    clearTimeout(window.__toastTimer);
    var toast = document.createElement('div');
    toast.id = 'cart-toast';
    toast.className = 'cart-toast';
    if (extraStyle) toast.style.cssText = extraStyle;
    toast.innerHTML = html;
    toast.style.opacity = '0';
    toast.style.transform = 'translateY(16px)';
    toast.style.transition = 'opacity 0.28s, transform 0.28s';
    document.body.appendChild(toast);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        toast.style.opacity = '1';
        toast.style.transform = 'translateY(0)';
      });
    });
    window.__toastTimer = setTimeout(function () {
      toast.style.opacity = '0';
      toast.style.transform = 'translateY(-8px)';
      setTimeout(function () { if (toast.parentNode) toast.remove(); }, 300);
    }, duration || 2700);
  }

  function showCartToast(name, imgSrc) {
    _showToast(
      '<div class="cart-toast__image"><img src="' + imgSrc + '" alt="" /></div>' +
      '<div style="flex:1;min-width:0">' +
        '<div class="cart-toast__status"><span class="material-symbols-outlined ms-fill">check_circle</span>Added to cart</div>' +
        '<div class="cart-toast__name">' + name + '</div>' +
      '</div>',
      2700
    );
  }

  /* ---- Add to Cart ---- */
  function updateCartBadge() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var countEl = document.querySelector('[data-cart-count]');
        if (countEl) {
          countEl.textContent   = cart.item_count;
          countEl.style.display = cart.item_count > 0 ? 'grid' : 'none';
        }
        var labelEl = document.querySelector('[data-cart-label]');
        if (labelEl) labelEl.textContent = cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's');
      })
      .catch(function () {});
  }

  function doAddToCart(variantId, qty, name, img) {
    var id = parseInt(variantId, 10);
    if (!id) return;
    var q = qty || 1;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: q }] })
    })
    .then(function (r) {
      if (!r.ok) {
        return r.json().then(function (errBody) {
          throw new Error(errBody.status === 422 ? 'policy' : (errBody.description || 'error'));
        });
      }
      return r.json();
    })
    .then(function () {
      // AJAX add succeeded
      showCartToast(name, img);
      updateCartBadge();
    })
    .catch(function (err) {
      if (err.message === 'policy') {
        // inventory_policy:deny is blocking the AJAX endpoint.
        // Fall back to the cart permalink — this is what worked before.
        showCartToast(name, img);
        // Add silently via fetch-followed redirect, then update badge
        fetch('/cart/' + id + ':' + q)
          .then(function () { updateCartBadge(); })
          .catch(function () {});
      }
      // For any other error we stay silent — item not added, no misleading toast
    });
  }

  // Product card "Add" links
  document.querySelectorAll('.product-card__add').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var variantId = link.dataset.variantId;
      if (!variantId) return; // variant not resolved — do nothing silently
      doAddToCart(
        variantId, 1,
        link.dataset.productName || '',
        link.dataset.productImg  || ''
      );
    });
  });

  // Product page "Add to Cart" form
  document.querySelectorAll('.product-buy-box form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var variantInput = form.querySelector('input[name="id"]');
      var variantId    = variantInput ? variantInput.value : '';
      if (!variantId) { form.submit(); return; }
      var qty = parseInt((form.querySelector('[data-qty]') || {}).value || 1, 10);
      var btn = form.querySelector('[data-add-to-cart]');
      var name = btn ? (btn.dataset.productName || '') : '';
      var img  = btn ? (btn.dataset.productImg  || '') : '';
      if (btn) { btn.disabled = true; setTimeout(function () { btn.disabled = false; }, 1500); }
      doAddToCart(variantId, qty, name, img);
    });
  });

  /* ---- Qty Stepper (product page) ---- */
  document.querySelectorAll('[data-qty-stepper]').forEach(function (stepper) {
    const minus = stepper.querySelector('[data-qty-minus]');
    const plus = stepper.querySelector('[data-qty-plus]');
    const input = stepper.querySelector('[data-qty]');
    if (minus && plus && input) {
      minus.addEventListener('click', function () {
        const v = parseInt(input.value);
        if (v > 1) { input.value = v - 1; input.dispatchEvent(new Event('change')); }
      });
      plus.addEventListener('click', function () {
        input.value = parseInt(input.value) + 1;
        input.dispatchEvent(new Event('change'));
      });
    }
  });

  /* ---- Product Tabs ---- */
  document.querySelectorAll('[data-tab-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const tabGroup = this.closest('[data-tabs]');
      if (!tabGroup) return;
      const target = this.dataset.tabBtn;
      tabGroup.querySelectorAll('[data-tab-btn]').forEach(b => b.classList.remove('active'));
      tabGroup.querySelectorAll('[data-tab-panel]').forEach(p => gsap.set(p, { display: 'none' }));
      this.classList.add('active');
      const panel = tabGroup.querySelector('[data-tab-panel="' + target + '"]');
      if (panel) {
        gsap.set(panel, { display: 'block' });
        gsap.fromTo(panel, { opacity: 0, y: 6 }, { opacity: 1, y: 0, duration: 0.2, ease: 'power2.out' });
      }
    });
  });

  /* ---- Product Gallery ---- */
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      const gallery = this.closest('[data-gallery]');
      if (!gallery) return;
      const idx = this.dataset.galleryThumb;
      const mainImg = gallery.querySelector('[data-gallery-main]');
      if (mainImg) mainImg.src = this.dataset.src;
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(t => t.classList.remove('product-thumb--active'));
      this.classList.add('product-thumb--active');
    });
  });

  /* ---- Filter Sidebar ---- */
  document.querySelectorAll('[data-filter-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const group = this.closest('.filter-group');
      if (!group) return;
      const items = group.querySelector('.filter-group__items');
      if (items) {
        const open = items.style.display !== 'none';
        if (open) {
          gsap.to(items, { opacity: 0, y: -4, duration: 0.18, ease: 'power2.in',
            onComplete() { gsap.set(items, { display: 'none', y: 0 }); } });
          this.classList.remove('open');
        } else {
          gsap.set(items, { display: 'flex', opacity: 0, y: -4 });
          gsap.to(items, { opacity: 1, y: 0, duration: 0.2, ease: 'power2.out' });
          this.classList.add('open');
        }
      }
    });
  });

  /* ---- Collection Sort ---- */
  const sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
    // Restore selected value from URL
    const params = new URLSearchParams(window.location.search);
    const sortBy = params.get('sort_by');
    if (sortBy) sortSelect.value = sortBy;
  }

  /* ---- Cart Page ---- */
  // Qty update buttons
  document.querySelectorAll('[data-cart-qty-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const line = parseInt(this.dataset.line);
      const dir = this.dataset.cartQtyBtn;
      const input = document.querySelector('[data-cart-line-qty="' + line + '"]');
      if (!input) return;
      const current = parseInt(input.value);
      const newQty = dir === 'plus' ? current + 1 : Math.max(1, current - 1);
      updateCartLine(line, newQty);
    });
  });

  document.querySelectorAll('[data-remove-line]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      updateCartLine(parseInt(this.dataset.removeLine), 0);
    });
  });

  function updateCartLine(line, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty }),
    }).then(() => window.location.reload());
  }

  /* ---- Checkout Form + Formspree ---- */
  // =========================================================
  //  ORDER_ENDPOINT — replace 'your_form_id' with your
  //  Formspree form ID from formspree.io (e.g. xabc1234).
  //  Until then, the form shows the popup but doesn't deliver.
  // =========================================================
  const ORDER_ENDPOINT = 'https://formspree.io/f/your_form_id';

  const checkoutForm = document.getElementById('checkout-form');
  const placeOrderBtn = document.getElementById('place-order-btn');

  if (checkoutForm && placeOrderBtn) {
    checkoutForm.addEventListener('submit', async function (e) {
      e.preventDefault();
      placeOrderBtn.disabled = true;
      placeOrderBtn.innerHTML = '<span class="material-symbols-outlined" style="animation:spin 1s linear infinite">progress_activity</span> Placing order…';

      const formData = new FormData(checkoutForm);
      const data = Object.fromEntries(formData.entries());
      const orderNo = 'SP-' + Math.floor(Math.random() * 90000 + 10000);

      const payload = {
        _subject: 'New order ' + orderNo + ' — Sorbpack',
        order_number: orderNo,
        ...data,
      };

      try {
        if (ORDER_ENDPOINT.includes('your_form_id')) {
          await new Promise(r => setTimeout(r, 700));
        } else {
          const res = await fetch(ORDER_ENDPOINT, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(payload),
          });
          if (!res.ok) throw new Error('submit failed');
        }
        showOrderPopup(orderNo);
      } catch (err) {
        // Fallback to mailto
        window.location.href =
          'mailto:info@sorbpack.com?subject=' + encodeURIComponent(payload._subject) +
          '&body=' + encodeURIComponent(JSON.stringify(data, null, 2));
        showOrderPopup(orderNo);
      } finally {
        placeOrderBtn.disabled = false;
        placeOrderBtn.innerHTML = '<span class="material-symbols-outlined">lock</span> Place order';
      }
    });
  }

  function showOrderPopup(orderNo) {
    let overlay = document.getElementById('order-popup-overlay');
    if (overlay) {
      gsap.set(overlay, { display: 'grid' });
      gsap.fromTo(overlay, { opacity: 0 }, { opacity: 1, duration: 0.2, ease: 'power2.out' });
      return;
    }
    overlay = document.createElement('div');
    overlay.id = 'order-popup-overlay';
    overlay.className = 'order-popup-overlay card';
    overlay.innerHTML = `
      <div class="order-popup card">
        <div class="order-popup__icon-wrap">
          <span class="material-symbols-outlined ms-fill order-popup__icon">check_circle</span>
        </div>
        <h2 class="display order-popup__title">Order placed!</h2>
        <p class="order-popup__msg">Thank you — your order <strong class="mono" style="color:var(--navy)">#${orderNo}</strong> has been sent to our team.</p>
        <p class="order-popup__sub">We'll reply <strong style="color:var(--navy)">within 1 hour</strong> with a payment link or pro forma invoice.</p>
        <div class="order-popup__email-note">
          <span class="material-symbols-outlined">mail</span> A confirmation has been sent to your email
        </div>
        <a href="/" class="btn btn-gold btn-block btn-lg">Continue shopping</a>
      </div>`;
    document.body.appendChild(overlay);
    gsap.fromTo(overlay, { opacity: 0 }, { opacity: 1, duration: 0.2, ease: 'power2.out' });
    const popup = overlay.querySelector('.order-popup');
    if (popup) gsap.fromTo(popup,
      { opacity: 0, scale: 0.9 },
      { opacity: 1, scale: 1, duration: 0.28, ease: 'back.out(1.4)' }
    );
  }

  /* ---- Free Shipping Bar ---- */
  // Handled server-side in Liquid, but keep for dynamic cart updates if needed

  /* ---- Checkout step toggle ---- */
  const checkoutBtn = document.getElementById('checkout-btn');
  const cartStep = document.getElementById('cart-step');
  const checkoutStep = document.getElementById('checkout-step');
  const checkoutStepIndicator = document.getElementById('step-checkout');
  const cartStepIndicator = document.getElementById('step-cart');

  if (checkoutBtn && cartStep && checkoutStep) {
    checkoutBtn.addEventListener('click', function () {
      gsap.to(cartStep, { opacity: 0, x: -20, duration: 0.22, ease: 'power2.in', onComplete() {
        gsap.set(cartStep, { display: 'none', x: 0 });
        gsap.set(checkoutStep, { display: 'block', opacity: 0, x: 20 });
        gsap.to(checkoutStep, { opacity: 1, x: 0, duration: 0.25, ease: 'power2.out' });
      }});
      if (checkoutStepIndicator) checkoutStepIndicator.classList.add('cart-step--active');
      if (cartStepIndicator) cartStepIndicator.classList.remove('cart-step--active');
      document.getElementById('cart-page-title').textContent = 'Secure checkout';
    });
  }

  const backToCartBtn = document.getElementById('back-to-cart-btn');
  if (backToCartBtn && cartStep && checkoutStep) {
    backToCartBtn.addEventListener('click', function () {
      gsap.to(checkoutStep, { opacity: 0, x: 20, duration: 0.22, ease: 'power2.in', onComplete() {
        gsap.set(checkoutStep, { display: 'none', x: 0 });
        gsap.set(cartStep, { display: 'block', opacity: 0, x: -20 });
        gsap.to(cartStep, { opacity: 1, x: 0, duration: 0.25, ease: 'power2.out' });
      }});
      if (checkoutStepIndicator) checkoutStepIndicator.classList.remove('cart-step--active');
      if (cartStepIndicator) cartStepIndicator.classList.add('cart-step--active');
      document.getElementById('cart-page-title').textContent = 'Your cart';
    });
  }

  /* ---- Scroll-triggered entrance animations ---- */
  if (typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);

    // Hero — fires on load, no scroll trigger needed (above the fold)
    if (document.querySelector('.hero__content')) {
      gsap.from('.hero__eyebrow',  { opacity: 0, y: 20, duration: 0.6, ease: 'power2.out', delay: 0.15, clearProps: 'transform,opacity' });
      gsap.from('.hero__title',    { opacity: 0, y: 28, duration: 0.7, ease: 'power2.out', delay: 0.3,  clearProps: 'transform,opacity' });
      gsap.from('.hero__desc',     { opacity: 0, y: 20, duration: 0.6, ease: 'power2.out', delay: 0.45, clearProps: 'transform,opacity' });
      gsap.from('.hero__ctas',     { opacity: 0, y: 16, duration: 0.55, ease: 'power2.out', delay: 0.58, clearProps: 'transform,opacity' });
      gsap.from('.hero__trust',    { opacity: 0, y: 12, duration: 0.5, ease: 'power2.out', delay: 0.7,  clearProps: 'transform,opacity' });
    }
    if (document.querySelector('.deal-card')) {
      gsap.from('.deal-card', { opacity: 0, x: 40, duration: 0.7, ease: 'power2.out', delay: 0.4, clearProps: 'transform,opacity' });
    }

    // Reusable: fade-up section header, then stagger child elements
    function revealSection(section, childSelector, stagger) {
      if (!section) return;
      const header = section.querySelector('.category-tiles__header, .product-row__header, .review-strip__header');
      if (header) {
        gsap.from(header, {
          scrollTrigger: { trigger: section, start: 'top 85%', once: true },
          opacity: 0, y: 24, duration: 0.55, ease: 'power2.out',
          clearProps: 'transform,opacity'
        });
      }
      const items = section.querySelectorAll(childSelector);
      if (items.length) {
        gsap.from(items, {
          scrollTrigger: { trigger: section, start: 'top 80%', once: true },
          opacity: 0, y: 30, duration: 0.5, ease: 'power2.out',
          stagger: stagger,
          clearProps: 'transform,opacity'
        });
      }
    }

    // Category tiles
    revealSection(document.querySelector('.category-tiles'), '.category-tile', 0.08);

    // Product rows (deals + bestsellers — same section type used twice)
    document.querySelectorAll('.product-row').forEach(function (row) {
      revealSection(row, '.product-card', 0.07);
    });

    // Promo split — left slides from left, right from right
    var promoSection = document.querySelector('.promo-split');
    if (promoSection) {
      var promos = promoSection.querySelectorAll('.promo-block');
      if (promos[0]) gsap.from(promos[0], {
        scrollTrigger: { trigger: promoSection, start: 'top 82%', once: true },
        opacity: 0, x: -36, duration: 0.6, ease: 'power2.out',
        clearProps: 'transform,opacity'
      });
      if (promos[1]) gsap.from(promos[1], {
        scrollTrigger: { trigger: promoSection, start: 'top 82%', once: true },
        opacity: 0, x: 36, duration: 0.6, ease: 'power2.out', delay: 0.1,
        clearProps: 'transform,opacity'
      });
    }

    // Review strip
    revealSection(document.querySelector('.review-strip'), '.review-card', 0.1);
  }

  /* ---- Mobile nav drawer ---- */
  var hamburger   = document.getElementById('nav-hamburger');
  var mobileNav   = document.getElementById('mobile-nav');
  var navClose    = document.getElementById('mobile-nav-close');
  var navBackdrop = document.getElementById('mobile-nav-backdrop');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (hamburger) hamburger.addEventListener('click', openMobileNav);
  if (navClose) navClose.addEventListener('click', closeMobileNav);
  if (navBackdrop) navBackdrop.addEventListener('click', closeMobileNav);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && mobileNav && mobileNav.classList.contains('is-open')) {
      closeMobileNav();
    }
  });

  /* ---- Payment option selection ---- */
  document.querySelectorAll('.payment-option').forEach(function (opt) {
    opt.addEventListener('click', function () {
      document.querySelectorAll('.payment-option').forEach(o => {
        o.classList.remove('payment-option--selected');
        o.querySelector('.payment-radio')?.classList.remove('payment-radio--selected');
        const dot = o.querySelector('.payment-radio__dot');
        if (dot) dot.style.display = 'none';
      });
      this.classList.add('payment-option--selected');
      const radio = this.querySelector('.payment-radio');
      if (radio) radio.classList.add('payment-radio--selected');
      const dot = this.querySelector('.payment-radio__dot');
      if (dot) dot.style.display = 'block';
      const input = this.querySelector('input[name="payment_method"]');
      if (input) input.checked = true;
    });
  });

});
